import { createApp } from "vue";
import { createPinia } from "pinia";
import "./styles/theme.css";
import App from "./App.vue";
import router from "./router";
import { setTokenProvider } from "./services/api";
import { registerCriticalRouter } from "./services/critical";
import { useSessionStore } from "./stores/session";

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);

  // Dev: мок REST + realtime без бэкенда (VUE_APP_MOCK_API=true). Условие литеральное — в прод не попадает.
  if (process.env.VUE_APP_MOCK_API === "true") {
    const { installMockApi } = await import(/* webpackChunkName: "dev-mock" */ "./dev/mockApi");
    installMockApi();
    // Витрина UI-примитивов: /ui-kit (или ?preview=ui-kit).
    router.addRoute({
      path: "/ui-kit",
      name: "ui-kit",
      component: () => import(/* webpackChunkName: "dev-mock" */ "./dev/UiKitScreen.vue"),
      meta: { back: "/" },
    });
  }

  setTokenProvider(() => useSessionStore(pinia).token);
  registerCriticalRouter(router);

  app.use(router);
  app.mount("#app");

  // Dev: доступ к сервисам из консоли браузера (window.__cb.realtime.send(...), __cb.game.$state …).
  if (process.env.VUE_APP_DEV_TOOLS === "true") {
    const [api, { default: realtime }, media, { useGameStore }] = await Promise.all([
      import("./services/api"),
      import("./services/realtime"),
      import("./services/media"),
      import("./stores/game"),
    ]);
    window.__cb = { api, realtime, media, router, session: useSessionStore(pinia), game: useGameStore(pinia) };
  }
}

bootstrap();
